import { Button } from "@peer-start/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { clearAllProductTourSessionDismissals } from "../../passport/components/product-tour-storage.js";
import { fetchLoginStatus, signOut } from "../api/client.js";
import { loginQueryKey } from "./LoginGate.js";

export function SignOut() {
  const { t } = useTranslation();
  const client = useQueryClient();
  const status = useQuery({ queryKey: loginQueryKey, queryFn: fetchLoginStatus });
  const logout = useMutation({
    mutationFn: signOut,
    onSuccess: ({ logoutUrl }) => {
      clearAllProductTourSessionDismissals();
      client.clear();
      window.location.assign(logoutUrl);
    },
  });
  if (!status.data?.enabled || !status.data.authenticated) return null;
  return (
    <div className="shrink-0">
      <Button
        controlId="login.sign-out"
        disabled={logout.isPending}
        onClick={() => logout.mutate()}
        variant="ghost"
      >
        {t("login.signOut")}
      </Button>
      {logout.isError ? (
        <span className="text-sm text-destructive" role="alert">
          {t("login.logoutFailed")}
        </span>
      ) : null}
    </div>
  );
}
